import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import http from 'http'

import parseSearchParams from 'fn/parseSearchParams'

import HumanizeNumber from 'components/HumanizeNumber'

const Top = ( {
  url,
  units,
  title = 'top',
  ceil = false
} ) => {
  const [ searchParams, setSeachParams ] = useSearchParams()
  const [ top, setTop ] = useState()

  useEffect( () => {
    const no = parseSearchParams( searchParams )

    http( {
      method: 'GET',
      url,
      params: {
        ...no
      }
    } )
      .then( ( { data } ) => {
        setTop( data )
      } )
  }, [ searchParams ] )

  if ( ! top )
    return null

  return <div className="hs">
    <div className="vs gap-2x air">
      <span className="one">{ title }</span>
    </div>

    <ul className="list-menu">

      { top.map( ( item, index ) => <li
        key={ index }
        className="list-item"
      >

        <span className="one text">
          { item.name }
        </span>

        <span className="text">
          <HumanizeNumber>
            { item.count }
          </HumanizeNumber>

          &nbsp;

          { units }
        </span>
      </li> ) }

    </ul>
  </div>

}

export default Top
